/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import URLs from '../utilities/URLs';

export interface IGetTimelineDataResponse {
  values: { [key: string]: string };
}

export async function getTimelineData(query): Promise<IGetTimelineDataResponse> {
  const queryString = new URLSearchParams();
  queryString.append('machineId', query.params.machineId);
  queryString.append('from', query.params.from);
  queryString.append('to', query.params.to);
  const response = await fetch(`${URLs.getTimelineData()}?${queryString.toString()}`);
  const data = await response.json();
  return data;
}
